export default __webpack_public_path__ + "static/media/image-23.67a0d397.webp";